export default "__VITE_PUBLIC_ASSET__50f7eacc__"